<template>
  <el-dialog
    :visible.sync="visible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    width="800px"
  >
    <div class="radishGoPoc">
      <div class="header">{{ $t('app.examTitle') }}</div>
      <el-form :model="form" :rules="rules" ref="form" class="ruleForm" label-position="top">
        <el-form-item :label="$t('app.examQ1')" prop="question1" required>
          <el-radio-group v-model="form.question1">
            <el-radio :label="1">{{ $t('common.yes') }}</el-radio>
            <el-radio :label="0">{{ $t('common.no') }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="$t('app.examQ2')" prop="question2" required>
          <el-radio-group v-model="form.question2">
            <el-radio :label="1">{{ $t('common.yes') }}</el-radio>
            <el-radio :label="0">{{ $t('common.no') }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="$t('app.examQ3')" prop="question3" required>
          <el-checkbox-group v-model="form.question3">
            <el-checkbox label="1">武汉</el-checkbox>
            <el-checkbox label="2">深圳</el-checkbox>
            <el-checkbox label="3">北京</el-checkbox>
            <el-checkbox label="4">上海</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <div class="footer">
        <el-button type="primary" @click="submitForm('form')">{{ $t('common.submit') }}</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    visible: Boolean
  },
  data() {
    return {
      form: {
        question1: undefined,
        question2: undefined,
        question3: [],
      },
      rules: {
        question1: [
          { required: true, message: this.$t('common.pleaseSelect'), trigger: 'blur' },
          // {
          //   validator: (rule, value, callback) => {
          //     if (value === 1) {
          //       callback(new Error('选择错误，请重新选择！'));
          //     } else {
          //       callback();
          //     }
          //   },
          //   trigger: 'submit'
          // }
        ],
        question2: [
          { required: true, message: this.$t('common.pleaseSelect'), trigger: 'blur' },
          // {
          //   validator: (rule, value, callback) => {
          //     if (value === 0) {
          //       callback(new Error('选择错误，请重新选择！'));
          //     } else {
          //       callback();
          //     }
          //   },
          //   trigger: 'submit'
          // }
        ],
        question3: [
          { type: 'array', required: true, message: this.$t('common.pleaseSelectOne'), trigger: 'blur' },
          { type: 'array', required: true, message: this.$t('common.pleaseSelectOne'), trigger: 'change' },
          // {
          //   validator: (rule, value, callback) => {
          //     if (!['1', '2', '3', '4'].every(v => value.includes(v))) {
          //       callback(new Error('未选择全，请重新选择！'));
          //     } else {
          //       callback();
          //     }
          //   },
          //   trigger: 'submit'
          // }
        ]
      }
    }
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid, data) => {
        if (valid) {
          if(this.form.question1 === 0 && this.form.question2 === 1 && ['1', '2', '3', '4'].every(v => this.form.question3.includes(v))) {
            this.$emit('close')
          } else {
            this.$confirm(this.$t('app.examWrongAnswer'), this.$t('common.tips'), {
              confirmButtonText: this.$t('common.confirm'),
              type: 'warning',
              center: true,
              showClose: false,
              closeOnPressEscape: false,
              closeOnClickModal: false,
              showCancelButton: false
            }).then(() => {
              this.resetForm('form')
            }).catch(() => {
              this.resetForm('form')
            });
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  },
};
</script>

<style lang="less" scoped>
.radishGoPoc {
  display: flex;
  flex-direction: column;
  align-items: center;
  .header {
    margin-bottom: 16px;
    font-size: 28px;
    font-weight: bold;
    color: #0e95fa;
  }
  .ruleForm {
    /deep/ .el-form-item__label {
      font-size: 16px;
    }
    /deep/ .el-radio__label {
      font-size: 16px;
    }
    /deep/ .el-checkbox__label {
      font-size: 16px;
    }
    .el-radio-group, .el-checkbox-group {
      display: flex;
      flex-direction: column;
      gap: 8px;
      padding-left: 10px;
      .el-checkbox {
        line-height: 20px;
      }
    }
  }
  .footer {
    margin-top: 38px;
    button {
      width: 160px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/radishGoPoc/index.vue